import { useState } from "react";
import { rankCategories, rankList, type RankItem } from "@/mocks/homeContent";

function trendIcon(t: RankItem["trend"]) {
  if (t === "up") return { cls: "ri-arrow-up-line text-primary-600", txt: "升" };
  if (t === "down") return { cls: "ri-arrow-down-line text-secondary-400", txt: "降" };
  return { cls: "ri-loader-4-line text-secondary-400", txt: "平" };
}

export default function HotRank() {
  const [active, setActive] = useState<string>("综合");
  const list = active === "综合" ? rankList : rankList.filter((r) => r.tag === active);

  return (
    <section id="hot" className="border-y border-secondary-200/70 bg-background-100/50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              <span className="mr-2 inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 align-middle text-background-50 md:h-10 md:w-10">
                <i className="ri-fire-fill text-lg leading-none md:text-xl"></i>
              </span>
              今日热度榜
            </h2>
            <p className="mt-2 text-sm text-foreground-600">按当前讨论量与上升速度综合排序，榜单一刻一变。</p>
          </div>
          {/* 圈层切换 */}
          <div className="inline-flex w-fit items-center gap-1 rounded-full border border-secondary-200 bg-background-50 p-1">
            {rankCategories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors md:text-sm ${
                  active === c
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:bg-secondary-100"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        {/* 榜单列表 */}
        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {list.map((item, i) => {
            const rank = item.id;
            const t = trendIcon(item.trend);
            const top3 = rank <= 3;
            return (
              <article
                key={item.id}
                className={`group flex items-start gap-4 rounded-2xl border p-4 transition-colors md:p-5 ${
                  top3
                    ? "border-primary-200/70 bg-gradient-to-br from-primary-50/80 to-background-50"
                    : "border-secondary-200/70 bg-background-50 hover:border-secondary-300"
                }`}
              >
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-display text-xl leading-none md:h-11 md:w-11 ${
                    top3
                      ? i === 0
                        ? "bg-primary-500 text-background-50"
                        : i === 1
                        ? "bg-primary-300 text-background-50"
                        : "bg-accent-400 text-background-50"
                      : "bg-secondary-100 text-secondary-700"
                  }`}
                >
                  {String(rank).padStart(2, "0")}
                </span>

                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="text-sm font-bold leading-6 text-foreground-950 md:text-base">
                      {item.title}
                    </h3>
                    <span
                      className={`mt-1 flex shrink-0 items-center gap-0.5 rounded-md px-1.5 py-0.5 text-xs font-semibold ${
                        t.txt === "升" ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-600"
                      }`}
                    >
                      <i className={`${t.cls} text-sm leading-none`}></i>
                      {t.txt}
                    </span>
                  </div>
                  <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-600 md:text-sm">
                    {item.summary}
                  </p>

                  <div className="mt-3 flex items-center gap-2">
                    <span className="whitespace-nowrap rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-700">
                      {item.tag}
                    </span>
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-secondary-100">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-600"
                        style={{ width: `${item.heat}%` }}
                      ></div>
                    </div>
                    <span className="whitespace-nowrap text-[11px] font-semibold text-primary-700">
                      热度 {item.heat}
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}